module.exports = __webpack_public_path__ + "img/image-252.46c4c99c.jpg";